import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWorkoutTemplateByApi } from "../../api/workoutTemplateApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchWorkoutTemplateByIdThunk = createAsyncThunk(
  Endpoints.GET_WORKOUT_TEMPLATE_BY_ID,
  async (coachId, { rejectWithValue }) => {
    try {
      const data = await fetchWorkoutTemplateByApi(coachId);

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const workoutTemplateSlice = createSlice({
  name: "getWorkoutTemplateById",
  initialState: {
    workoutTemplateByID: null,
    isloading: false,
    error: null,
    successMessage: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutTemplateByIdThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(fetchWorkoutTemplateByIdThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutTemplateByID = action.payload;
      })
      .addCase(fetchWorkoutTemplateByIdThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      });
  },
});

export const workoutTemplateByIdReducer = workoutTemplateSlice.reducer;
